import React from 'react';
import { IconProps } from '.';

const SvgCirclePlayFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Z' />
      <path fill='#fff' d='m17 12-8 5V7l8 5Z' />
    </svg>
  );
};

export default SvgCirclePlayFill;
